import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[480px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20illustration%20of%20interconnected%20flowing%20lines%20and%20circles%20representing%20social%20networks%20and%20human%20connections%2C%20soft%20amber%20coral%20and%20cream%20gradients%2C%20elegant%20minimalist%20composition%2C%20gentle%20organic%20flowing%20shapes%2C%20editorial%20style%2C%20warm%20sophisticated%20atmosphere%2C%20harmonious%20balanced%20design&width=1800&height=1240&seq=hero-main-bg&orientation=landscape"
        alt="姐姐的朋友 - 社交人脉拓展"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-3xl mx-auto">
          {siteConfig.tagline}
        </h1>
        <p className="mt-4 md:mt-6 text-base md:text-lg text-white/80 max-w-xl mx-auto leading-relaxed">
          你打开优质社交圈子的最佳切入点。学习如何通过姐姐的朋友拓展人脉、建立信任，在新圈子中快速站稳脚跟。
        </p>
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/jiejie-pengyouquan"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm transition-all whitespace-nowrap cursor-pointer"
          >
            开始探索
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full text-sm transition-all backdrop-blur-sm whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}